import { render, staticRenderFns } from "./AddBenefit.vue?vue&type=template&id=4f4e6230&scoped=true"
import script from "./AddBenefit.vue?vue&type=script&lang=js"
export * from "./AddBenefit.vue?vue&type=script&lang=js"
import style0 from "./AddBenefit.vue?vue&type=style&index=0&id=4f4e6230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4e6230",
  null
  
)

export default component.exports